export default __webpack_public_path__ + "static/media/arrow-next-small.26eca6da.svg";